import type { DatabaseStatus } from '../lib/types'

const TONE: Record<DatabaseStatus, string> = {
  creating: 'building',
  available: 'live',
  failed: 'failed',
  suspended: 'suspended',
  deleting: 'busy',
  deleted: 'idle',
}

const LABEL: Record<DatabaseStatus, string> = {
  creating: 'Provisioning',
  available: 'Available',
  failed: 'Failed',
  suspended: 'Suspended',
  deleting: 'Deleting',
  deleted: 'Deleted',
}

export default function DatabaseBadge({ status }: { status: DatabaseStatus }) {
  return <span className={`badge ${TONE[status]}`}>{LABEL[status]}</span>
}

